import styles from './index.module.css'
import { Checkbox } from '@appkit4/react-components/checkbox'
import classnames from 'classnames'

export const View = ({ label, fontSize, className, ...props }) => {
    const labelFont = {
        '--checkbox-label-font-size': `${fontSize}px`
    }
    return (
        <Checkbox className={classnames(styles.default, className)} style={labelFont} {...props}>
            {label}
        </Checkbox>
    )
}
